const moduleName = "Estadísticas";

const READ_STATISTICS = "Ver estadísticas";

export default {
  moduleName,
  READ_STATISTICS
};
